export function HtmlField({ field }: any) {
  const config = field.config;
  return <div dangerouslySetInnerHTML={{ __html: config.htmlContent || config.label || '' }} />;
}
